module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Bold.083f0f4.woff";